import {Injectable} from '@angular/core';
import {Message} from './message.model';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {ApiConnectService} from '../../../services/api-connect.service';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import * as moment from 'moment';
import {eraseStyles} from '@angular/animations/browser/src/util';

@Injectable()
export class MessageService {
  // чаты от стандарта тут будут храниться
  private confChatMessages: Message[] = [];
  private famChatMessages: Message[] = [];
  public currentChat: number; // currentChat: 1 - confChatMessages; 2 - famChatMessages;

  private showInputBlock = false;
  public chatName = '';
  private standard: any;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private stepsControllerService: StepsControllerService,
              private router: Router,
              private userService: UserService) {
  }

  doShowInputBlock() {
    return this.showInputBlock;
  }

  setSshowInputBlock(flag: boolean) {
    this.showInputBlock = flag;
  }

  addMessage(message: string) {
    let standardID;
    if (this.router.url.includes('confirm-standard/') ||
      this.router.url.includes('familiarize-standard/')) {
      standardID = this.standard.id;
    } else {
      standardID = this.stepsControllerService.getCurrentStandard().id;
    }

    const reqHeaders = new HttpHeaders({'offset': this.userService.getTimezoneOffset()});
    this.http.post(this.apiURL.sendPost + standardID + '/message', {text: message}, {observe: 'response', headers: reqHeaders})
      .subscribe(
        (res: any) => {
          if (res.status === 200 || res.status === 201) {
            const uName = res.body.senderName;
            // Добавить сообщение в локальный лист
            if (this.currentChat === 1) {
              this.confChatMessages.reverse();
              this.confChatMessages.push(res.body);
              this.confChatMessages.reverse();
            } else if (this.currentChat === 2) {
              this.famChatMessages.reverse();
              this.famChatMessages.push(res.body);
              this.famChatMessages.reverse();
            }
          }
        },
        () => {
        }
      );
  }

  getMessages() {
    if (this.router.url.includes('confirm-standard/')) {
      this.chatName = 'Confirmation chat';
      return this.returnConfChatMessages(false);
    } else if (this.router.url.includes('familiarize-standard/')) {
      this.chatName = 'Reviews';
      return this.returnFamChatMessages(false);
    } else {
      const status = this.stepsControllerService.getCurrentStandard().status.toString();
      if (status === 'UNDER_CONFIRMATION' || status === 'NEW') {
        this.chatName = 'Confirmation chat';
        return this.returnConfChatMessages(true);
      } else if (status === 'UNDER_FAMILIARIZATION') {
        this.chatName = 'Reviews';
        return this.returnFamChatMessages(true);
      }
    }
  }

  setTempStandard(tempStandard) {
    this.standard = tempStandard;
  }

  returnConfChatMessages(isFromSteps: boolean): Message[] {
    let sStatus = '';
    if (!isFromSteps) {
      this.confChatMessages = this.standard.confirmationChat.messages;
      sStatus = this.standard.status;
    } else {
      this.confChatMessages = this.stepsControllerService.getCurrentStandard().confirmationChat.messages;
      sStatus = this.stepsControllerService.getCurrentStandard().status;
    }

    if (sStatus === 'UNDER_CONFIRMATION') {
      this.showInputBlock = true;
    }

    this.currentChat = 1;
    this.confChatMessages.reverse();
    return this.confChatMessages;
  }

  returnFamChatMessages(isFromSteps: boolean): Message[] {
    let sStatus = '';
    let aID = '';
    if (!isFromSteps) {
      this.famChatMessages = this.standard.familiarizationChat.messages;
      sStatus = this.standard.status.toString();
      aID = this.standard.author.id;
    } else {
      this.famChatMessages = this.stepsControllerService.getCurrentStandard().familiarizationChat.messages;
      sStatus = this.stepsControllerService.getCurrentStandard().status.toString();
      aID = this.stepsControllerService.getCurrentStandard().author.id;
    }
    if (sStatus === 'UNDER_FAMILIARIZATION') {
      if (this.router.url.includes('familiarize-standard/')) {
        // this.showInputBlock = true;
      } else {
        this.showInputBlock = aID !== this.userService.getLocal().id.toString();
      }
    } else {
      this.showInputBlock = false;
    }

    this.currentChat = 2;
    this.famChatMessages.reverse();
    return this.famChatMessages;
  }

  hasFamChatMyMessage(userID) {
    if (this.famChatMessages.length > 0) {
        const userMessage = this.famChatMessages.find(item => item.userId === userID);
        if (userMessage) {
          this.showInputBlock = false;
          return true;
        } else {
          this.showInputBlock = true;
          return false;
        }
    } else {
      this.showInputBlock = true;
      return false;
    }
  }

  readMessages() {
    let sID;
    if (this.router.url.includes('confirm-standard/') ||
      this.router.url.includes('familiarize-standard/')) {
      sID = this.standard.id;
    } else {
      sID = this.stepsControllerService.getCurrentStandard().id;
    }
    this.http.post(this.apiURL.readNotifications + sID, null).subscribe(
      (res: any) => {
      },
      () => {
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/chat/message.service.ts